import React, {FC, Fragment} from "react"

import {CompanyNewsTile, LayoutWidgets, LayoutWidgetConfig, LayoutWidgetType} from "@irati/types"

import CompanyNews from "../CompanyNews"
import TenantProducts from "../TenantProducts"
import {HomePageView} from "../types"

interface Props {
  companyNews: CompanyNewsTile[],
  id: string,
  layoutWidgets: LayoutWidgets,
  pageView: HomePageView,
  isAdmin: boolean,
  openModal?: boolean
}

const ManageHomePageLayout: FC<Props> = ({companyNews, id, layoutWidgets, pageView, isAdmin, openModal}) => {
  return (
    <>
      {layoutWidgets.config.map(({content}: LayoutWidgetConfig, index: number) => (
        <Fragment key={content.type}>
          {content.type === LayoutWidgetType.CompanyNews && (
            <CompanyNews id={id} pageView={pageView} isAdmin={isAdmin} companyNews={companyNews} openModal={openModal} />
          )}
          {content.type === LayoutWidgetType.Products && <TenantProducts id={id} pageView={pageView} alignOverlayToBottom={index > 0} />}
        </Fragment>
      ))}
    </>
  )
}

export default ManageHomePageLayout
